var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: {
        active: _vm.active,
        messages: true,
        "has-messages": _vm.count && _vm.count > 0
      }
    },
    [
      _c("a", { attrs: { href: _vm.link } }, [
        _vm._v("\n\t\t" + _vm._s(_vm.linkText) + "\n\t\t"),
        _vm.count
          ? _c("span", { staticClass: "count-bubble" }, [
              _vm._v(_vm._s(_vm.count))
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }